export const fleetsPatternConstants = {
  NAME_PATTERN: /^.{1,100}$/,
}
